(function () {
  "use strict";

  var THRESHOLD_SELECTOR = "[data-kg-shipping-threshold]";
  var STRINGS_SELECTOR = "[data-kg-threshold-strings]";
  var GIFT_PROPERTY_KEY = "_kg_free_gift";

  function toNumber(value) {
    var num = Number(value);
    return Number.isFinite(num) ? num : 0;
  }

  function parseBool(value) {
    return String(value) === "true";
  }

  function formatMoney(cents, currencySymbol) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : "${{amount}}");
    }

    var amount = (toNumber(cents) / 100).toFixed(2).replace(/\.00$/, "");
    return (currencySymbol || "$") + amount;
  }

  function fillTemplate(template, amountText) {
    if (!template) return amountText;
    return template.indexOf("[amount]") > -1 ? template.replace("[amount]", amountText) : template + " " + amountText;
  }

  function getThresholdStrings() {
    var el = document.querySelector(STRINGS_SELECTOR);
    if (!el) return null;

    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function getMerchandiseTotal(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;

    return cart.items.reduce(function (sum, item) {
      var isGift = item && item.properties && String(item.properties[GIFT_PROPERTY_KEY]) === "1";
      if (isGift) return sum;
      return sum + toNumber(item.final_line_price);
    }, 0);
  }

  function findGiftLine(cart) {
    if (!cart || !Array.isArray(cart.items)) return null;
    for (var i = 0; i < cart.items.length; i += 1) {
      var item = cart.items[i] || {};
      var props = item.properties || {};
      if (String(props[GIFT_PROPERTY_KEY]) === "1") {
        return item;
      }
    }
    return null;
  }

  function parseVariantId(value) {
    var normalized = String(value || "").replace(/[^\d]/g, "");
    return normalized ? parseInt(normalized, 10) : 0;
  }

  function addGiftVariant(variantId) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: { _kg_free_gift: "1" }
      })
    }).then(function (res) {
      return res.ok;
    });
  }

  function removeGiftLine(lineKey) {
    var updates = {};
    updates[String(lineKey || "")] = 0;
    return fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ updates: updates })
    }).then(function (res) {
      return res.ok;
    });
  }

  function syncFreeGift(cart, root) {
    if (!root || !cart) return Promise.resolve(false);

    var giftTier = parseBool(root.dataset.kgGiftTier);
    var giftThreshold = toNumber(root.dataset.kgGiftThreshold);
    var giftVariantId = parseVariantId(root.dataset.kgGiftVariantId);
    var giftLine = findGiftLine(cart);
    var merchTotal = getMerchandiseTotal(cart);
    var shouldHaveGift = giftTier && giftThreshold > 0 && giftVariantId > 0 && merchTotal >= giftThreshold && toNumber(cart.item_count) > 0;

    if (shouldHaveGift && !giftLine) {
      return addGiftVariant(giftVariantId).catch(function () {
        return false;
      });
    }

    if (!shouldHaveGift && giftLine && giftLine.key) {
      return removeGiftLine(giftLine.key).catch(function () {
        return false;
      });
    }

    return Promise.resolve(false);
  }

  function updateThreshold(root, cart, strings) {
    if (!root || !cart) return;

    var threshold = toNumber(root.dataset.kgThreshold);
    var barMax = toNumber(root.dataset.kgBarMax) || threshold;
    var giftTier = parseBool(root.dataset.kgGiftTier);
    var giftThreshold = toNumber(root.dataset.kgGiftThreshold);
    var currency = root.dataset.kgCurrency || "$";

    var msgEl = root.querySelector("[data-kg-threshold-msg]");
    var barEl = root.querySelector("[data-kg-threshold-bar]");
    var shipMilestoneEl = root.querySelector("[data-kg-milestone-ship]");
    var giftMilestoneEl = root.querySelector("[data-kg-milestone-gift]");

    var merchTotal = getMerchandiseTotal(cart);
    var remainingShip = threshold - merchTotal;
    var remainingGift = giftThreshold - merchTotal;
    var hasItems = toNumber(cart.item_count) > 0;

    var progress = hasItems && barMax > 0 ? (merchTotal / barMax) * 100 : 0;
    progress = Math.max(0, Math.min(100, progress));

    var shipDone = hasItems && remainingShip <= 0;
    var giftDone = giftTier && hasItems && remainingGift <= 0;

    if (barEl) {
      barEl.style.width = progress + "%";
    }

    root.classList.toggle("kg-shipping-threshold--ship-done", shipDone);
    root.classList.toggle("kg-shipping-threshold--gift-done", giftDone);
    root.classList.toggle("kg-shipping-threshold__success", shipDone);

    if (shipMilestoneEl) {
      shipMilestoneEl.classList.toggle("kg-shipping-threshold__milestone--done", shipDone);
    }
    if (giftMilestoneEl) {
      giftMilestoneEl.classList.toggle("kg-shipping-threshold__milestone--done", giftDone);
    }

    if (!msgEl || !strings) return;

    var message = "";
    if (!hasItems) {
      message = fillTemplate(strings.empty, formatMoney(threshold, currency));
    } else if (remainingShip > 0) {
      message = fillTemplate(strings.progressShip, formatMoney(remainingShip, currency));
    } else if (giftTier && remainingGift > 0) {
      message = fillTemplate(strings.progressGift, formatMoney(remainingGift, currency));
    } else if (giftTier && giftDone) {
      message = strings.successGift || "You've unlocked your free gift!";
    } else {
      message = strings.successShip || "You have unlocked free shipping!";
    }

    msgEl.textContent = message;
  }

  function refreshThresholds() {
    var roots = document.querySelectorAll(THRESHOLD_SELECTOR);
    if (!roots.length) return;

    var strings = getThresholdStrings();

    fetch("/cart.js")
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (cart) {
        if (!cart) return;
        var primaryRoot = roots[0];
        return syncFreeGift(cart, primaryRoot).then(function (changed) {
          if (!changed) return cart;
          return fetch("/cart.js").then(function (res2) {
            return res2.ok ? res2.json() : cart;
          }).then(function (latestCart) {
            try {
              document.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true, detail: { cart: latestCart } }));
              document.dispatchEvent(new CustomEvent("ajaxProduct:added", { bubbles: true, detail: { cart: latestCart } }));
            } catch (e) {
              /* noop */
            }
            return latestCart;
          });
        });
      })
      .then(function (latestCart) {
        if (!latestCart) return;
        roots.forEach(function (root) {
          updateThreshold(root, latestCart, strings);
        });
      })
      .catch(function () {
        /* noop */
      });
  }

  var refreshTimeout = null;
  function queueRefresh() {
    window.clearTimeout(refreshTimeout);
    refreshTimeout = window.setTimeout(refreshThresholds, 180);
  }

  function isCartMutationUrl(url) {
    if (!url) return false;
    return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i.test(String(url));
  }

  function installCartRequestHooks() {
    if (window.fetch && !window.__kgThresholdFetchHooked) {
      window.__kgThresholdFetchHooked = true;
      var nativeFetch = window.fetch;
      window.fetch = function (resource, init) {
        var url = typeof resource === "string" ? resource : resource && resource.url;
        return nativeFetch.apply(this, arguments).then(function (response) {
          if (isCartMutationUrl(url)) {
            queueRefresh();
          }
          return response;
        });
      };
    }

    if (window.XMLHttpRequest && !window.__kgThresholdXhrHooked) {
      window.__kgThresholdXhrHooked = true;
      var nativeOpen = XMLHttpRequest.prototype.open;
      var nativeSend = XMLHttpRequest.prototype.send;

      XMLHttpRequest.prototype.open = function (method, url) {
        this.__kgThresholdUrl = url;
        return nativeOpen.apply(this, arguments);
      };

      XMLHttpRequest.prototype.send = function () {
        this.addEventListener("loadend", function () {
          if (isCartMutationUrl(this.__kgThresholdUrl)) {
            queueRefresh();
          }
        });
        return nativeSend.apply(this, arguments);
      };
    }
  }

  document.addEventListener("DOMContentLoaded", refreshThresholds);
  document.addEventListener("cart:updated", queueRefresh);
  document.addEventListener("ajaxProduct:added", queueRefresh);
  installCartRequestHooks();

  function initKgDispatchTimers(scope) {
    var root = scope || document;
    root.querySelectorAll(".kg-dispatch-banner:not([data-kg-dispatch-init])").forEach(function (banner) {
      banner.setAttribute("data-kg-dispatch-init", "true");
      var productRoot =
        banner.closest("[data-product-blocks]") ||
        banner.closest(".product-section") ||
        banner.closest(".modal--quick-shop") ||
        root;
      var paymentButtons = productRoot.querySelector(".payment-buttons");

      if (paymentButtons) {
        paymentButtons.prepend(banner);
      }

      var countdownEl = banner.querySelector(".kg-dispatch-banner__time");
      if (!countdownEl) return;

      function updateCountdown() {
        var now = new Date();
        var bstNow = new Date(
          now.toLocaleString("en-US", {
            timeZone: "Europe/London"
          })
        );
        var targetTime = new Date(bstNow);

        targetTime.setHours(22, 0, 0, 0);

        if (bstNow > targetTime) {
          targetTime.setDate(targetTime.getDate() + 1);
        }

        var difference = targetTime - bstNow;
        var hours = Math.floor(difference / (1000 * 60 * 60));
        var minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((difference % (1000 * 60)) / 1000);

        countdownEl.textContent =
          String(hours).padStart(2, "0") +
          ":" +
          String(minutes).padStart(2, "0") +
          ":" +
          String(seconds).padStart(2, "0");
      }

      updateCountdown();
      window.setInterval(updateCountdown, 1000);
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initKgDispatchTimers();
  });
  document.addEventListener("quickview:loaded", function () {
    initKgDispatchTimers();
  });
})();
